import { Mark } from "@tiptap/core";
import Image from "@tiptap/extension-image";
import { cropStyles } from "../../../shared/utils/crop-styles";

export const Highlight = Mark.create({
  name: "highlight",
  renderHTML({ HTMLAttributes }) {
    return ["span", { ...HTMLAttributes, style: "background-color: rgba(0, 255, 0, 0.2); color: green;" }, 0];
  }
});

export const CroppedImage = Image.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      tlx: { default: 0 },
      tly: { default: 0 },
      brx: { default: 0 },
      bry: { default: 0 },
      w: { default: 0 },
      h: { default: 0 },
      imageId: { default: 0 }
    };
  },
  renderHTML({ node, HTMLAttributes }) {
    const { src, tlx, tly, brx, bry, w, h, imageId } = node.attrs;
    const { wrapper, img } = cropStyles(tlx, tly, brx, bry, w, h);
    return [
      "div",
      { style: wrapper },
      [
        "img",
        {
          ...HTMLAttributes,
          src,
          style: img,
          imageid: imageId
        }
      ]
    ];
  }
});
